import React from 'react'
import { useTranslation } from 'react-i18next'
import { DescriptionFieldProps } from '../../../../../../../@types/types'
import { DescriptionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextArea from '../../../../../../common/inputs/textArea/TextArea'

export const AdOther: React.FC<DescriptionFieldProps<DescriptionScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='grid-item margin-top-m'>
      <TextArea
        id='ad-other-text'
        name='adOther'
        rows={3}
        placeholder={t(
          'wizard.screen.description.adOtherPlaceholder',
          'e.g. For what is the property suitable, specific features'
        )}
        allowResize={true}
        value={insertionData.adOther}
        errors={validationMessages!.adOther ?? []}
        label={t('wizard.screen.description.adOther', 'Other')}
        showMaxLengthLabel={true}
        maxLength={2000}
        onChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
